module.exports = __webpack_public_path__ + "img/sintesis.c129e577.svg";